import React from "react";
import Header from "./Header";
import classes from "./RootLayout.module.css";
import Sidebar from "./Sidebar";
import { Outlet } from "react-router";

const RootLayout = () => {
  return (
    <div>
      <Header />
      <Sidebar />
      <main className={classes.main}>
        <Outlet />
      </main>
    </div>
  );
}

export default RootLayout;
